/* V721: imported single-cell collection descriptions are prose, not data grids. */
(function () {
  'use strict';
  function normalizeCollectionProse(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var tables = scope.querySelectorAll('.collection--description table');
    for (var i = 0; i < tables.length; i++) {
      var table = tables[i];
      // Leave real tables, headers, captions and nested layouts untouched.
      if (table.querySelector('th, caption, table, thead, tfoot') || !table.rows || table.rows.length !== 1) continue;
      var cells = table.rows[0].cells;
      if (!cells || cells.length !== 1 || cells[0].tagName !== 'TD') continue;
      if (cells[0].colSpan !== 1 || cells[0].rowSpan !== 1) continue;
      table.classList.add('integy-v721-prose-table');
      // V722: this is layout prose; do not announce a one-cell data table.
      // Preserve an explicit role supplied by the merchant.
      if (!table.hasAttribute('role')) table.setAttribute('role', 'presentation');
    }
  }
  function boot() { normalizeCollectionProse(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    normalizeCollectionProse(event.target);
  });
})();
